export default "__VITE_ASSET__4c4f5f35__"